//src/app/features/orders/index.tsx
/**
 * Display combined payments (orders, projects, tax extensions, services)
 * using the backend /payments endpoint.
 */
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useLazyGetPaymentsQuery } from 'app/services/payments/payments';
import {
  PaymentRecord,
  IOrder,
  IProject,
  ISubscribedServicesItems,
} from 'app/services/responseTypes';
import { ITaxExtension } from 'app/services/taxExtensions';
import PaginatedList from 'Components/Pagination/PaginatedList';
import usePagination from 'Components/Pagination/usePagination';

import OrderItem from './OrderItem';
import ProjectOrderItem from './ProjectOrderItem';
import TaxExtensionOrderItem from './TaxExtensionOrderItem';
import ServiceOrderItem from './ServiceOrderItem';

export default function Orders() {
  const { data, Pagination } = usePagination(useLazyGetPaymentsQuery, {
    per_page: 3,
    filters: {},
  });

  const items: PaymentRecord[] = Array.isArray(data) ? data : [];

  return (
    <>
      <DashboardContainerHeader title="Orders" />
      <PaginatedList
        data={items}
        Pagination={Pagination}
        className="p-3"
        renderItem={(item: PaymentRecord) => {
          switch (item.payment_type) {
            case 'order':
              return <OrderItem order={item as IOrder} />;
            case 'project':
              return <ProjectOrderItem project={item as IProject} />;
            case 'tax_extension':
              return (
                <TaxExtensionOrderItem extension={item as ITaxExtension} />
              );
            default:
              return (
                <ServiceOrderItem service={item as ISubscribedServicesItems} />
              );
          }
        }}
      />
    </>
  );
}
